import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  backendUrl: 'https://dev-password.woolworths.com.au',
  recaptchaKey: '6LdE_sopAAAAAFOwWpF7dDoim-NOxFo8_It-_wQc',
  bigWResetUrl: 'https://bigw-dev.identitynow.com/passwordreset/default/reset-password',
  endeavourGroupResetUrl: 'https://idm.endeavourgroup.com.au/passwordreset/default/reset-password',
  successFactorsUrl: 'https://performancemanager10.successfactors.com/login?company=C0001087662D'
};
